import { lazy, Suspense } from 'react';
import type { CustomGlobeProps } from './travel-globes/types';

const CustomTexturedTravelGlobe = lazy(() => import('./travel-globes/CustomTexturedTravelGlobe'));

interface TravelGlobeProps extends CustomGlobeProps {
  loadingText: string;
}

export default function TravelGlobe({ loadingText, ...props }: TravelGlobeProps) {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-[420px] items-center justify-center rounded-lg border border-neutral-200 bg-white p-6 text-center text-sm font-mono text-coffee shadow-soft transition-shadow duration-200 hover:shadow-float md:min-h-[560px]">
          {loadingText}
        </div>
      }
    >
      <CustomTexturedTravelGlobe {...props} />
    </Suspense>
  );
}
